<template>
  <div>
    <v-row>
      <v-col xs12 sm6 md6>
        <v-select
          :items="devices"
          item-value="code"
          item-text="description"
          label="Port"
          v-model="smsConfig.port"
          return-object
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col xs12 sm6 md6>
        <v-text-field
          label="Contact Number"
          v-model="smsConfig.contactNumber"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col xs12 sm6 md6>
        <v-textarea
          label="Message"
          class="input-7-1"
          v-model="smsConfig.message"
        ></v-textarea>
      </v-col>
    </v-row>
    <v-row>
      <v-col xs12 sm12 md12>
        <v-btn text outlined @click="testSMS" :loading="isSending">Test</v-btn>
        &nbsp;
        <v-btn text outlined :loading="isSaving" @click="add">Add</v-btn>
      </v-col>
    </v-row>

    <v-data-table :items="items" :headers="headers">
      <!-- <template slot="items" slot-scope="{ item }">
        <td>{{ item.port }}</td>
        <td>{{ item.portDesc }}</td>
        <td>
          <v-checkbox
            :input-value="item.isActive"
            @change="isActiveChanged($event, item)"
          ></v-checkbox>
        </td>
      </template> -->
      <template v-slot:item.isActive="{ item }">
        <v-checkbox
          :input-value="item.isActive"
          @change="isActiveChanged($event, item)"
        ></v-checkbox>
      </template>
    </v-data-table>
  </div>
</template>
<script>
const API_ENDPOINT = "/api/smsConfig";
export default {
  data: () => ({
    active: null,
    // title: "SMS Con",
    onEdit: false,
    smsConfig: {},
    devices: [],
    isSending: false,
    isSaving: false,
    items: [],
    headers: [
      { text: "Port", value: "port", sortable: false },
      { text: "Description", value: "portDesc", sortable: false },
      { text: "Is Active", value: "isActive", sortable: false },
    ],
  }),
  methods: {
    getConnectedDevices() {
      this.$axios
        .get(`${API_ENDPOINT}/com`)
        .then(({ data }) => {
          this.devices = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    testSMS() {
      this.isSending = true;
      this.$axios
        .post(`${API_ENDPOINT}/test`, {
          Port: this.smsConfig.port.code,
          Name: this.smsConfig.port.description,
          ContactNumber: this.smsConfig.contactNumber,
          Message: this.smsConfig.message,
        })
        .then(({ data }) => {
          this.isSending = false;
          this.$toast.success(data.message);
        })
        .catch(({ response }) => {
          this.isSending = false;
          this.$toast.error(response.data.message);
        });
    },
    add() {
      this.isSaving = true;
      this.$axios
        .post(`${API_ENDPOINT}`, {
          Port: this.smsConfig.port.code,
          PortDesc: this.smsConfig.port.description,
        })
        .then(({ data }) => {
          this.isSaving = false;
          this.getSMSConfig();
          this.$toast.success(data.message);
        })
        .catch(({ response }) => {
          this.isSaving = false;
          this.$toast.error(response.data.message);
        });
    },
    getSMSConfig() {
      this.$axios
        .get(`${API_ENDPOINT}`)
        .then(({ data }) => {
          if (data.length > 0) {
            this.items = [];
            this.items.push(data);
          }
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    isActiveChanged(e, item) {
      this.$axios
        .post(`${API_ENDPOINT}`, {
          Port: item.port,
          PortDesc: item.portDesc,
          IsActive: e,
        })
        .then(({ data }) => {
          this.getSMSConfig();
          this.$toast.success(data.message);
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
  },
  created() {
    this.getConnectedDevices();
    this.getSMSConfig();
  },
};
</script>
